import { useMemo } from 'react';
import { getUnavailableDay } from './utils';

const useIsUnavailableDay = () => {
  const unavailableDay = useMemo(() => {
    const day = getUnavailableDay();
    if (day) {
      day.isFullDay = !day.hours;
    }
    return day;
  }, []);

  return {
    showAnnouncement: Boolean(unavailableDay),
    announcementDay: unavailableDay,
  };
};

export default useIsUnavailableDay;
